import React, { useState, useEffect, useRef } from "react";
import Typed from "typed.js";
import { useSelector } from "react-redux";
import { useParams, useNavigate, Link } from "react-router-dom";
import confetti from "canvas-confetti";
import { isMobile } from "react-device-detect";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import { jwtDecode } from "jwt-decode";


const Home_CBT = () => {
  const navigate = useNavigate();
  
  const { id } = useParams(); // Retrieve the dynamic id from the route params

  const typedRef = useRef(null);

  const schoolname = localStorage.getItem("schoolname");

  const user = useSelector((state) => state.auth?.user);

  // Get user details
  const firstName = user?.firstName || ""; // Default to empty if not available
  const studid = user?.studid || "";

  const axiosInstance = axios.create({
      baseURL: `/${id}/v3`, // Adjust base URL dynamically
      headers: {
          "Content-Type": "application/json",
      },
  });

  useEffect(() => {
    const typed = new Typed(typedRef.current, {
      strings: [
        "Hello "+firstName+"...",
        "Get Ready For Exam!",
        "Make Sure To Read Instructions...",
        "Get Your Your Writing Materials With You!",
      ],
      typeSpeed: 50,
      backSpeed: 30,
      loop: true,
    });

    return () => {
      typed.destroy();
    };
  }, []);

  const typedElement = useRef(null);
  const typedInstance = useRef(null);

  useEffect(() => {
    confetti({
      particleCount: 500,
      spread: 100,
      origin: { y: 0.6 },
      colors: ["#ffffff", "#d291bc", "#957dad"],
    });
  }, []);

  const [cbtList, setCbtList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0); // default selected is first

  const [subject, setSubject] = useState(""); 

  
  
  const getCbtList = async () => {

    const studclass = user?.studclass || "";

    const token = localStorage.getItem("token");

    if (!token) return;

    try {
      const response = await axiosInstance.post("/take-cbt/my-tasks", {
        studclass,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const { success, tasks } = response.data;

      if (success && Array.isArray(tasks)) {
        setCbtList(tasks);
      } else {
        setCbtList([]);
      }

    } catch (error) {
      console.error("Failed to fetch CBT tasks:", error);
      setCbtList([]);
    }
  };

  useEffect(() => {
    getCbtList();
  }, []);

  useEffect(() => {
    const unlockedCbts = cbtList.filter(cbt => cbt.security !== "Locked");
    if (unlockedCbts.length > 0) {
      setSubject(unlockedCbts[0].cbt_subject); // Default to first unlocked subject
      setToken(unlockedCbts[0].token_id)
    }
  }, [cbtList]);

  const [passcode, setPassword] = useState("");
  const [tokenid, setToken] = useState("");
  const [status, setStatus] = useState(false);
  const [passwordType, setPasswordType] = useState("password");

  const togglePassword = () => {
    setPasswordType((prev) => (prev === "password" ? "text" : "password"));
  };

  const clickSoundRef = useRef(null);
  
  useEffect(() => {
    clickSoundRef.current = new Audio("/assets/sound/3.mp3"); // place the sound file in /public/assets/sound
  }, []);

  const playSound = () => {
    if (clickSoundRef.current) {
      clickSoundRef.current.currentTime = 0; // rewind to start
      clickSoundRef.current.play().catch((e) => {
        console.warn("Sound play failed:", e);
      });
    }
  };

  const handleLogin = async (e) => {
    playSound();
    e.preventDefault();
    setStatus(true);

    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const response = await axiosInstance.post(
        "/take-cbt/open",
        {
          studid,
          passcode,
          tokenid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === "success") {
        toast.success("✅ Login successful!");

        const token_id = response.data.token;
        if (token_id) {
          const decodedUser = jwtDecode(token_id);
          localStorage.setItem("jwtDecode", JSON.stringify(decodedUser));

          setTimeout(() => {
            setStatus(false);
            navigate(`/${id}/take-cbt/started`, { state: {
              trigger: null,
              required: null,
              message: null,
              cbtId: tokenid,
              user: decodedUser
            }, });
          }, 2000);
        } else {
          navigate("/${id}/take-cbt/started"); // Go back if no token
        }

      } 
      
      else if (response.data.status === "completed") {
        toast.info("🛑 You have already completed this CBT.");
        setStatus(false);
        navigate(`/${id}/take-cbt/home`); // redirect to a completed view
      } 

      else {
        throw new Error("Invalid credentials");
      }
      
    } catch (error) {
      toast.error("❌ Login Failed! Incorrect details.");
      console.error(error);
      setStatus(false);
    }
  };
  
  return (
    <div className="bg-back">
     
     <div className="fixed-top">
        <div className="bg-white" style={{ left: "300px" }}>
        <div className="row d-flex px-4 align-items-center">
            <div className="d-none d-lg-flex col-lg-3">
            <div className="mt-2 mb-2">
            <div className="fs-t text-dark fw-medium">
                {schoolname}
            </div>
            </div>
            </div>

            <div className="col-lg-6 col-9 ms-lg-n6">
            <div className="mt-1 mb-2">
            <div className="fs-t text-dark fw-medium">
                <span className="text-dark">CBT {" "}
                <span className="fs-1">e</span>Stream<span className="fs-1">.</span></span>
            </div>
            </div>
            </div>

            <div className="col-lg-3 col-3 text-end ms-lg-4">
            <Link to={"/"+id+"/logout-cbt"}>
                <div className="mt-2 mb-2">
                <i class="bi bi-power fs-t text-dark fw-medium"></i>
                </div>
            </Link>
            </div>

        </div>
        </div>
     </div>

     {loading ? (
        <>
        {!isMobile ?
        <div
            className="sidebar-loader bg-white p-4"
            style={{
            width: "300px",
            height: "100vh",
            overflowY: "auto",
            borderRight: "1px solid #eee",
            }}
        >
            <div className="mt-16">
            {[...Array(5)].map((_, i) => (
            <Skeleton
                key={i}
                height={35}
                className="mb-3 py-5"
                style={{ borderRadius: "10px" }}
            />
            ))}
        </div>
        </div>
        :
        <></>
        }
        <Skeleton height={40} className="mb-3" />
        </>
        ) : (
        <>
        {isMobile ?
        <></>
        :
        <div
            class="docs-nav-sidebar border-none bg-white shadow-none"
            style={{ width: "300px", border: "none", height: "700px" }}
        >
            <div class="py-5">
            
            </div>
            
            <div class=" docs-nav" data-simplebar>
            <nav class="navigation navbar navbar-expand-lg mt-8">
                <div class="collapse navbar-collapse mb-0" id="navbarNav">
                <ul
                    class="navbar-nav flex-column text-start px-4 shadow-none mb-15"
                    id="sidebarnav"
                >   

                 <li className="mt-2 mb-3 bg-transparent">
                    <div className="text-start text-dark fs-3">
                      All Subjects
                    </div>
                 </li>

                  {cbtList
                    .filter(cbt => cbt.security !== "Locked")
                    .map((cbt, index) => (
                      <li key={index} className="mb-3">
                        <div
                          onClick={() => {
                            setActiveIndex(index);
                            setSubject(cbt.cbt_subject);
                            setToken(cbt.token_id)
                          }}
                          className={`card p-4 text-center position-relative overflow-hidden shadow-none cursor-pointer ${
                            index === activeIndex ? "bg-tiles text-white" : "bg-back text-dark"
                          }`}
                          style={{
                            borderRadius: "20px",
                          }}
                        >
                          <i
                            className="bi bi-journal-text position-absolute"
                            style={{
                              fontSize: "5rem",
                              top: "-20px",
                              right: "-20px",
                              transform: "rotate(-25deg)",
                              opacity: 0.15,
                              pointerEvents: "none",
                            }}
                          ></i>
                          <div className="fs-4 fw-semibold mb-1">{cbt.title}</div>
                          <div className="small fs-5">
                            {cbt.cbt_subject} • {cbt.timer} mins
                          </div>
                          <div className="small fs-5">{cbt.task_type}</div>
                        </div>
                      </li>
                  ))}

                </ul>
                </div>
            </nav>
            </div>
        </div>
        }

      <div className="docs-wrapper bg-back"
      style={isMobile ? {} : { left: "50px", width: "calc(100% - 300px)" }}>
        <div className="position-relative overflow-hidden px-0 bg-purple4 pt-10 pt-lg-16 pb-8 pb-lg-14">
          {/* 🎉 Gradient Waves */}
          <div className="gradient-waves position-absolute top-0 start-0 w-100 h-100 z-n1"></div>

          {/* ✨ Floating Icons */}
          <div className="floaty-icon icon1">
            <i className="bi bi-mortarboard-fill fs-1 text-gray-100"></i>
          </div>
          <div className="floaty-icon icon2 fs-t text-gray-100">
            <i className="bi bi-123 fs-1 text-gray-300"></i>
          </div>
          <div className="floaty-icon icon3">
            <i className="bi bi-balloon-fill fs-1 text-gray-100"></i>
          </div>

          {/* 🏆 Trophy Cup Floating Top Right */}
          <div
            className="floating-trophy position-absolute top-0 end-0 me-5 mt-5 z-1"
            style={{ transform: "rotate(18deg)", opacity: 0.5 }}
          >
            <i
              className="bi bi-trophy-fill text-gray-100"
              style={{ fontSize: "6rem" }}
            ></i>
          </div>

          <div className="container-fluid px-6 px-lg-10">
            <div className="row align-items-center">
              <div className="col-12 col-lg-12">
                <div className="text-white fs-t2 fw-medium">
                  <span ref={typedRef}></span>
                </div>
                <p className="text-white fs-4 mb-0">
                  
                </p>
              </div>

              
            </div>
          </div>
        </div>

        <div className="container-fluid px-2 px-lg-10 pt-lg-12 pt-8 pb-10 pb-lg-10 mt-lg-n18 mt-n12">
          <div
            className="card bg-white shadow-none px-lg-6 px-4 py-4"
            style={{ borderRadius: "18px" }}
          >
            <div className="row gx-6 gy-4 align-items-center">
              <div className="d-flex align-items-center">
                <div className="col">
                  <div className="fs-t text-gray-700 fw-medium">
                    <span className="">{firstName} Ready For {subject}</span>
                  </div>
                  <div className="text-dark fs-4 fw-medium">
                    <p className="text-dark mb-6">

                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 px-lg-8 mb-6">
               
                <div className="row gx-6 gy-4 align-items-center justify-content-between">
                  
                  <form className="row px-lg-15 text-center" onSubmit={handleLogin}>
                    <div className="col-lg-12 mb-5">
                    <input
                    type="text"
                    className="form-control form-control-lg bg-back rounded-pill"
                    placeholder="What is your student ID?"
                    value={studid}
                    required
                    />
                    </div>

                    <div className="form-group mb-5 position-relative">
                        <input
                        type={passwordType}
                        className="form-control form-control-lg bg-back rounded-pill"
                        placeholder="Enter your password"
                        required
                        onChange={(e) => setPassword(e.target.value)}
                        />
                        <span
                        className="position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer text-dark"
                        onClick={togglePassword}
                        >
                        <i
                            className={`bi ${
                            passwordType === "password"
                                ? "bi-eye-fill text-dark"
                                : "bi-eye-slash-fill text-dark"
                            }`}
                        ></i>
                        </span>
                    </div>

                    <div className="col-lg-12">
                    <button
                    type="submit"
                    className="w-50 btn btn-purple py-3 rounded-pill"
                    disabled={status}
                    >
                    {status ? (
                          <>
                            <span className="spinner-border spinner-border-sm text-dark" role="status" aria-hidden="true"></span>
                            <span className="text-dark">Getting Ready...</span>
                          </>
                        ) : (
                          <>
                            <i className="bi bi-stars text-warning"></i> Get Started
                          </>
                    )}
                    </button>
                    </div>
                    
                  </form>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      </>
      )}
    </div>

  );
};

export default Home_CBT;
